import { Routes } from "@angular/router";
import { AuthGuard } from "./helpers/auth.guard";
import { AuthGuard2 } from "./auth/auth.guard";
import { AdminLayoutComponent } from "./layouts/admin/admin-layout.component";
import { AuthLayoutComponent } from "./layouts/auth/auth-layout.component";

export const AppRoutes: Routes = [
  {
    path: "",
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "terms",
        loadChildren: () => import("./terms/terms.module").then(m => m.TermsModule),
      },
      {
        path: "users",
        loadChildren: () => import("./users/users.module").then(m => m.UsersModule),
      },
      {
        path: "contact",
        loadChildren: () => import("./contact/contact.module").then(m => m.ContactModule),
        canActivate: [AuthGuard2],
      },
      {
        path: "pbi",
        loadChildren: () => import("./pbi/pbi.module").then(m => m.PbiModule),
        canActivate: [AuthGuard2],
      },
      {
        path: "roles",
        loadChildren: () => import("./roles/roles.module").then(m => m.RolesModule),
        canActivate: [AuthGuard2],
      },
      {
        path: "files",
        loadChildren: () => import("./files/files.module").then(m => m.FilesModule),
        canActivate: [AuthGuard2]
      },
      {
        path: "solicitacoes",
        loadChildren: () => import("./solicitacoes/solicitacoes.module").then(m => m.SolicitacoesModule),
        canActivate: [AuthGuard2]
      },
      {
        path: "dashboard",
        loadChildren: () => import("./dashboard/dashboard.module").then(m => m.DashboardModule),
        canActivate: [AuthGuard2]
      },
      {
        path: "relatorio/:name",
        loadChildren: () => import("./relatorio/relatorio.module").then(m => m.RelatorioModule),
        canActivate: [AuthGuard2]
      }
    ],
  },
  {
    path: "",
    component: AuthLayoutComponent,
    children: [
      {
        path: "pages",
        loadChildren: () => import("./pages/pages.module").then(m => m.PagesModule),
      },
    ],
  },
  {
    path: "**",
    redirectTo: "dashboard",
    pathMatch: "full",
  },
];
